var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFragilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.527,
    height: 35.659,
    fill: "#007cc2",
    viewBox: "0 0 32.527 40.659",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-42.666)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.177,0H65.029a1.017,1.017,0,0,0-.909.562L62.086,4.628a1.019,1.019,0,0,0,.038.978l2.535,4.227L59.287,13.19l.645-3.875a1.013,1.013,0,0,0-.189-.776L57.151,5.082l2.593-3.456A1.017,1.017,0,0,0,58.93,0H43.683a1.016,1.016,0,0,0-1.017,1.017V6.1A16.259,16.259,0,0,0,56.9,22.2v14.4H53.46a2.033,2.033,0,0,0-1.818,1.124l-.736,1.471a1.017,1.017,0,0,0,.909,1.471H66.044a1.017,1.017,0,0,0,.909-1.471l-.736-1.471A2.033,2.033,0,0,0,64.4,36.593H60.963V22.2A16.259,16.259,0,0,0,75.193,6.1V1.017A1.016,1.016,0,0,0,74.177,0Z",
    transform: "translate(-42.666)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFragilIcon);
export default __webpack_public_path__ + "static/media/fragilIcon.50372da53ecbeb2a9b161edf8fdcea9a.svg";
export { ForwardRef as ReactComponent };